import React, { useState } from 'react'
import { TextField, Typography } from '@material-ui/core'
import PropTypes from 'prop-types'
import axios from 'axios'

// components
import Dialog from '../../../../../components/Dialog'

export default function HiringForecasFormDlg(props) {

	const [forecastName, setForecastName] = useState('')
	const [forecastDescription/*, setForecastDescription*/] = useState('--')
	const [forecastErr, setForecastErr] = useState('')

	const saveForecast = async () => {
		setForecastErr('')

		if(forecastName === '') {
			setForecastErr('Name is required')
			return
		}

		const payload = {
			name: forecastName,
			description : forecastDescription,
		}

		try {
            await axios.post(`/api/forecast`, payload)
            props.onSuccess()
        } catch(e) {
            setForecastErr('Sorry, we are unable to create Forecast')
        }
	}


	return (
		<Dialog
			size={'sm'}
			title={'Hiring Forecast'}
			isOpen={props.isOpen}
			onClose={() => props.onClose()}
			actions={[
				{
					title: 'Cancel',
					func: () => {
						props.onClose()
					},
				},
				{
					title: 'Create',
					func: async () => {
						await saveForecast()
					},
				},
			]}
		>
			<>
				{
					forecastErr ?
						<Typography>{forecastErr}</Typography>
						:
						null
				}
				<TextField
					autoFocus
					value={forecastName}
					onChange={(e) => setForecastName(e.target.value)}
					margin='dense'
					id='name'
					label='Set Hiring Forecast Name'
					type="text"
					fullWidth
					required
				/>
			</>
		</Dialog>
	)
}

HiringForecasFormDlg.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	onSuccess: PropTypes.func.isRequired,
}
